/**
 * <sunday-never>: the press in the compressed-mattress card plays once by itself when half the card is on
 * screen: lifted, pressed under the elephants, rolled into a box, opened (the spine on the thin mattress
 * pulses), then back to rest (pressed flat). The round button plays it again. Under 960 a two-option switch (data-nr-view) swaps the two cards in place. With reduced motion it never
 * plays by itself; the drawing stays at its end state. CSS reacts to data-beat (0 rest, 1 pressed,
 * 2 rolled, 3 opened) and data-lift.
 */
const STEPS = [
  [80, 1],
  [2400, 2],
  [4400, 3],
];
const END = 7400;

class SundayNever extends HTMLElement {
  connectedCallback() {
    this.btn = this.querySelector('[data-nr-btn]');
    this.card = this.querySelector('.sd-nr-bx') || this;
    this.timers = [];
    this.playing = false;
    if (this.btn) this.btn.addEventListener('click', () => this.play());
    this.querySelectorAll('[data-nr-view]').forEach((b) =>
      b.addEventListener('click', () => {
        this.setAttribute('data-view', b.dataset.nrView);
        this.querySelectorAll('[data-nr-view]').forEach((o) => o.setAttribute('aria-pressed', String(o === b)));
      })
    );
    const still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (still || !('IntersectionObserver' in window)) return;
    this.io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          this.io.disconnect();
          this.io = null;
          this.play();
        }
      },
      { threshold: 0.5 }
    );
    this.io.observe(this.card);
  }

  play() {
    if (this.playing) return;
    this.playing = true;
    if (this.btn) this.btn.setAttribute('aria-disabled', 'true');
    this.timers.forEach(clearTimeout);
    this.timers = [];
    this.setAttribute('data-lift', '');
    this.setAttribute('data-beat', '1');
    for (const [ms, beat] of STEPS) {
      this.timers.push(
        setTimeout(() => {
          if (beat === 1) this.removeAttribute('data-lift');
          else this.setAttribute('data-beat', String(beat));
        }, ms)
      );
    }
    this.timers.push(
      setTimeout(() => {
        this.setAttribute('data-beat', '0');
        this.playing = false;
        if (this.btn) this.btn.removeAttribute('aria-disabled');
      }, END)
    );
  }

  disconnectedCallback() {
    (this.timers || []).forEach(clearTimeout);
    if (this.io) this.io.disconnect();
  }
}

if (!customElements.get('sunday-never')) customElements.define('sunday-never', SundayNever);
